<template>
  <div class="link-hotspot">
    <Steps
      v-if="step1"
      :title="$t('edit.hpInfo.hpIcon')"
      :isShowArrow="true"
      @clickBack="onClickPreTo(-1)"
      @onClickNext="onClickNextTo(2)"
    >
      <template slot="body">
        <HListWithBtn :displayStyle="2">
          <template slot="body">
            <Icons @onSelectIcon="onSelectIcon" :currentIcon="wordObj.icon_url"></Icons>
          </template>
        </HListWithBtn>
      </template>
    </Steps>

    <Steps
      v-if="step2"
      :title="$t('edit.hpInfo.hpTitle')"
      :isShowArrow="true"
      @clickBack="onClickPreTo(1)"
      @onClickNext="onClickNextTo(3)"
    >
      <template slot="body">
        <a-input :placeholder="$t('edit.hpInfo.inputTitle')"
        v-model="wordObj.title" style="width:75%" />
        <a-input :placeholder="currFontSize" 
        v-model="currFontSize" style="width:15%; margin-left:10%" />
      </template>
    </Steps>

    <Steps
      v-if="step3"
      :title="$t('common.inputContent')"
      :isShowArrow="true"
      displayType
      @clickBack="onClickPreTo(2)"
      @onClickNext="onClickNextTo(4)"
    >
      <template slot="body">
        <a-textarea :placeholder="$t('common.inputContent')" :rows="2" v-model="wordObj.content" />
      </template>
    </Steps>

    <Steps
      v-if="step4"
      :title="$t('edit.hpInfo.hpTitleSetting')"
      :isShowArrow="true"
      :isLast="true"
      @clickBack="onClickPreTo(3)"
      @onClickFinish="onClickFinish"
    >
      <template slot="body">
        <div class="titSetting" v-if="!moreSetting">
          <a-button class="tit_position_btn" type="primary" v-for="(item, index) in btnPosition" 
          :key="index" @click="onClickBtn(item, index)"
          :class="{ tit_active: index == currentPosition }">
              {{ item.name }}
          </a-button>
        </div>
        <div v-else style="width:100%">
          <a-row>
            <a-col :span="6" style="padding:5px">
              {{ $t('edit.hpInfo.title_x') }}
            </a-col>
            <a-col :span="18">
              <a-slider :min="-100" :max="100" :step="1" v-model="curr_x" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" style="padding:5px">
              {{ $t('edit.hpInfo.title_y') }}
            </a-col>
            <a-col :span="18">
              <a-slider :min="-100" :max="100" :step="1" v-model="curr_y" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" style="padding:5px">
              <span>icon大小</span>
            </a-col>
            <a-col :span="12">
              <a-slider :min="10" :max="200" :step="1" v-model="currScale" />
            </a-col>
            <a-col :span="6">
              <a-button type="primary" style="float: right;"
              class="tit_active" @click="backToSetting()">
                返回
              </a-button>
            </a-col>
          </a-row>
        </div>
      </template>
    </Steps>
  </div>
</template>

<script>
import Icons from "./Icons.vue";
import Steps from "../../Steps.vue";
import HListWithBtn from "../../HListWithBtn.vue";
import { v4 as uuidv4 } from "uuid";
// import { mapGetters } from "vuex";

export default {
  components: { Icons, Steps, HListWithBtn },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      btnPosition:[
        { name: "上",align:'top',edge:'bottom',x:0,y:0,},
        { name: "下",align:'bottom',edge:'top',x:0,y:0,},
        { name: "左",align:'right',edge:'right',x:50,y:10,},
        { name: "右",align:'left',edge:'left',x:50,y:10,},
        { name: "進階",align:'',edge:'',x:0,y:0,},
      ],
      step1: true,
      step2: false,
      step3: false,
      step4: false,
      wordObj: {
        type: "word",
        hotspot_id: "hotspot_" + uuidv4(),
        icon_url: "",
        is_dynamic: 1,
        ath: "",
        atv: "",
        title: "",
        is_show_title: 1,
        content: "",
        titleFontSize:16,
        tit_position_align:"top",
        tit_position_edge:"bottom",
        tit_position_x:0,
        tit_position_y:0,
        icon_scale:50,
      },
      currFontSize:20,
      currScale:50,
      currentPosition: 0,
      curr_align:"top",
      curr_edge:"bottom",
      curr_x:0,
      curr_y:0,
      moreSetting:false,
    };
  },
  mounted() {
    this.$bus.$on("updateHotspot", (e) => {
      if (e.hotspot_id == this.wordObj.hotspot_id) {
        this.wordObj.ath = e.ath;
        this.wordObj.atv = e.atv;
      }
    });
  },
  computed: {
    // ...mapGetters(["vrbase", "currentScenesId"]),
    newLinkObj() {
      return this.$deepClone(this.wordObj);
    },
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          this.wordObj = value;
          this.currFontSize = this.wordObj.titleFontSize;
          console.log(typeof(this.currFontSize));
          this.currScale = this.wordObj.icon_scale;
          this.curr_x = this.wordObj.tit_position_x;
          this.curr_y = this.wordObj.tit_position_y;
          if (this.wordObj.tit_position_align == "top") {
            this.currentPosition = 0;
          } else if (this.wordObj.tit_position_align == "bottom") {
            this.currentPosition = 1;
          } else if (this.wordObj.tit_position_align == "left") {
            this.currentPosition = 2;
          } else if (this.wordObj.tit_position_align == "right") {
            this.currentPosition = 3;
          } else {
            this.currentPosition = 0;
            this.wordObj.tit_position_align = 'top';
          }
        }
      },
      immediate: true,
      deep: true,
    },
    newLinkObj: {
      handler: function (val, oldVal) {
        if (val.ath == "" && val.atv == "") {
          const vh = getSceneViewAt();
          this.wordObj.ath = vh.hlookat;
          this.wordObj.atv = vh.vlookat;
        }
        this.wordObj.is_show_title = this.wordObj.title == "" ? 0 : 1;
        this.$emit("change", this.wordObj, oldVal);
      },
      deep: true,
    },
    currScale:{
      handler:function(value){
        const id = this.wordObj.hotspot_id;
        setIconScale(id, value);
      },
      deep: true,
    },
    curr_x:{
      handler:function(value){
        const id = this.wordObj.hotspot_id;
        const x = 'x';
        setTitlePosition(id, value, x);
      },
      deep: true,
    },
    curr_y:{
      handler:function(value){
        const id = this.wordObj.hotspot_id;
        const y = 'y'
        setTitlePosition(id, value, y);
      },
      deep: true,
    },
    currFontSize:{
      handler:function(value){
        const id = this.wordObj.hotspot_id;
        const css = 'css';
        var value = 'text-align:center; color:#FFFFFF; font-family:MicrosoftYahei; font-size:'+value+'px';
        setTitlePosition(id, value, css);
      },
      deep: true,
    },
  },
  methods: {
    backToSetting(){
      this.moreSetting = !this.moreSetting;
    },
    onClickBtn(item, index){
      if (index === 4){
        this.moreSetting = !this.moreSetting;
      }else {
        this.currentPosition = index;
        const currId = this.wordObj.hotspot_id;
        setHotspotTitlePosition(item, currId);
        this.curr_align = item.align;
        this.curr_edge = item.edge;
        this.curr_x = item.x
        this.curr_y = item.y;
      }
    },
    onSelectIcon(item) {
      this.wordObj.icon_url = item.icon_url;
      this.wordObj.is_dynamic = item.is_dynamic;
    },
    onClickFinish() {
      this.wordObj.titleFontSize = this.currFontSize;
      this.wordObj.icon_scale = this.currScale;
      this.wordObj.tit_position_align = this.curr_align;
      this.wordObj.tit_position_edge = this.curr_edge;
      this.wordObj.tit_position_x = this.curr_x;
      this.wordObj.tit_position_y = this.curr_y;
      this.$emit("saveDataToStore", {
        key: this.wordObj.hotspot_id,
        data: this.wordObj,
      });
    },
    onClickPreTo(value) {
      if (value === -1) {
        this.$emit("onClickBack");
      } else if (value === 1) {
        this.step1 = true;
        this.step2 = false;
        this.step3 = false;
      } else if (value === 2) {
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      } else if (value === 3) {
        this.step1 = false;
        this.step2 = false;
        this.step3 = true;
        this.step4 = false;
      }
    },
    onClickNextTo(value) {
      if (value === 2) {
        if (!this.wordObj.icon_url) {
          this.$message.error(this.$t('edit.hpInfo.hpIcon'));
          return;
        }
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
        this.step4 = false;
      } else if (value === 3) {
        this.step1 = false;
        this.step2 = false;
        this.step3 = true;
        this.step4 = false;
      } else if (value === 4) {
        this.step1 = false;
        this.step2 = false;
        this.step3 = false;
        this.step4 = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tit_position_btn{
  color: #fff;
  background-color: #404040;
  border-color: #2e2e2e;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #555;
}
.tit_position_btn:hover{
  background-color: #02a2aa;
  border-color: #02a2aa;
  border: 1px solid #fff;
}
.tit_active{
  background-color: #015c61;
  border-color: #015c61;
}
.titSetting{
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 15%;
}
.ant-slider-track{
  background-color: #015c61;
}
</style>
